<div class="component-card">
    <div style="display: inline-block;width: 100%;">
        <h1 class="component-title">{{'SYSTEM_PROFILES.TECH_SUPPORT'|translate}}</h1>
        <i class="pi pi-ellipsis-v spam-menu"></i>
    </div>
    <div class="panel_wrapper">
        <div class="d-flex flex-row  pb-4">
            <div class="p-inputgroup div_search_field w-50">
                <button type="button" class="search_btn_icon" (click)="searhTechSupport(searchTechSupportModel)"><i class="pi pi-search"></i></button>
                <input type="text" class="input_text_search_field" (keydown.enter)="searhTechSupport(searchTechSupportModel)" [(ngModel)]="searchTechSupportModel.name" placeholder="{{'SEARCH' | translate}}...">
                <button type="button" class="search_btn_icon" (click)="clearSearch()" ><i class="pi pi-times"></i></button>
            </div>
            <button class="btn_in_color w-25" (click)="addNewTechSupport()" >{{ 'SYSTEM_PROFILES.ADD_NEW' | translate}} +</button>
            <div class="float-end d-flex ms-auto">
                <label class="lbl_number">{{totalRecords}}</label>
                <i class="pi pi-user big_icon"></i>
            </div>
        </div>
    </div>
</div>

<div style="padding-right: 4px; height: 430px;overflow-y: auto;overflow-x: hidden;" infiniteScroll
    [infiniteScrollDistance]="2" [infiniteScrollUpDistance]="1000" (scrolled)="loadMoreTechSupport()" [scrollWindow]="false">
    <div *ngFor="let techSupport of techSupportList" class="component-card">
        <div class="component-list-card">
            <div class="d-flex flex-row justify-content-between">
                <div class="d-flex flex-row me-3" style="align-items: self-end;">
                    <img class="admin_picture_list" [src]="techSupport.profilePictureUrl ? techSupport.profilePictureUrl:imagePath " alt="profile-picture">
                    <div class="admin_info ">
                        <h5 class="title"><span>{{techSupport.firstName}}
                            </span><span>{{techSupport.lastName}}</span></h5>
                        <div class="admin_role">
                            <i class="pi pi-user"></i>
                            <span> {{techSupport.roleName}} </span>
                        </div>
                    </div>
                </div>
                <div class="div_group_list">
                    <div class="div_lbl_group">
                        <label class="lbl_color_list">{{ 'SYSTEM_PROFILES.EMAIL' | translate }}</label>
                        <label class="lbl_list">{{ techSupport.email }}</label>
                    </div>
                    <div class="div_lbl_group">
                        <label class="lbl_color_list">{{ 'SYSTEM_PROFILES.PHONE' | translate }}</label>
                        <label class="lbl_list">{{ techSupport.phone }}</label>
                    </div>
                </div>
                <div class="ms-2">
                    <button class="btn_in_color w-100 mb-2" (click)="editTechSupport(techSupport.id)">{{ 'EDIT' | translate}}</button>
                    <button class="btn_without_color btn_border_color w-100" (click)="deleteTechSupport(techSupport.id)">{{ 'DELETE' | translate}}</button>
                </div>
            </div>
        </div>
    </div>
</div>
